/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 老项目域名地址
 * khglUrl: 客户管理域名地址
 * dicUrl : 字典服务器地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 * welUrl :默认欢迎页
 *
 */

const def = {
	reqType: 'json', // 请求类型   单独配置：type （下同）
	reqMethod: 'post', // 请求方式
	tokenName: 'access-token' // 请求 token 字段名
}


let baseUrl = ''
const env = process.env
if (env.NODE_ENV === 'development') {
	baseUrl = `https://xcx.zhonghun001.com/lixin/api/gw` // 开发环境地址

	// baseUrl = `http://122.114.49.242:8074/lixin/api/gw` // 开发环境地址
} else if (env.NODE_ENV === 'production') {
	baseUrl = `https://xcx.zhonghun001.com/lixin/api/gw` // 生产环境地址

	// baseUrl = `http://122.114.49.242:8074/lixin/api/gw` // 开发环境地址
} else if (env.NODE_ENV === 'test') {
	baseUrl = `` // 测试环境地址
}
export {
	baseUrl,
	env,
	def
}


// WEBPACK FOOTER //
// ./src/config/env.js